import { useAccountFormContext, useAccountPageContext } from '../context';
import { ACCOUNT_LOOKUP_COLUMNS } from '../cols-definition';
import { FormFieldV2, SearchFieldV2 } from '@/components/custom/erp';
import type { AccountModel } from '@/types/schemas';
import { Label } from '@/components/ui/label';

export const BasicInfoTab = () => {
  const form = useAccountFormContext();
  const page = useAccountPageContext();
  const isViewMode = form.mode === 'view';

  return (
    <div className='p-4' onChangeCapture={form.markDirty}>
      <div className='space-y-1'>
        <div className='flex flex-col sm:flex-row sm:items-center'>
          <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tài khoản</Label>
          <FormFieldV2 type='text' name='code' className='w-[200px]' disabled={isViewMode} />
        </div>

        <div className='flex flex-col sm:flex-row sm:items-center'>
          <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tên tài khoản</Label>
          <FormFieldV2 type='text' name='name' className='w-[400px]' disabled={isViewMode} />
        </div>

        <div className='flex flex-col sm:flex-row sm:items-center'>
          <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tên tiếng Anh</Label>
          <FormFieldV2 type='text' name='account_name_2' className='w-[400px]' disabled={isViewMode} />
        </div>

        <div className='flex flex-col sm:flex-row sm:items-center'>
          <Label className='w-40 min-w-40'>Tài khoản mẹ</Label>
          <SearchFieldV2<AccountModel>
            rows={page.rows}
            searchColumns={ACCOUNT_LOOKUP_COLUMNS}
            dialogTitle='Danh mục tài khoản'
            dialogBaseZIndex={1600}
            onRowSelection={(row: AccountModel | null) => form.setParentAccount(row)}
            disabled={isViewMode}
            columnDisplay='code'
            displayRelatedField='name'
            value={form.parentAccount?.code ?? ''}
            relatedFieldValue={form.parentAccount?.name ?? ''}
            className='w-100'
          />
        </div>
      </div>

      <div className='mt-1 flex flex-col sm:flex-row sm:items-center'>
        <Label className='mb-2 sm:mb-0 sm:w-40 sm:min-w-40'>Tên tiếng khác</Label>
        <FormFieldV2 type='text' name='account_name_3' className='w-[400px]' disabled={isViewMode} />
      </div>
    </div>
  );
};
